import { render, staticRenderFns } from "./BarTrendTDWidget.vue?vue&type=template&id=b3a4283c&scoped=true"
import script from "./BarTrendTDWidget.vue?vue&type=script&lang=js"
export * from "./BarTrendTDWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a4283c",
  null
  
)

export default component.exports